var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OutreachRequestsTable',_vm._g({attrs:{"items":_vm.items,"columns":_vm.columns}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }